"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { BlockInspectorProps, InspectorProps } from "../../lib/inspector";
import { ImageSection, type ImageSectionProps } from "./image-section";

export type ImageSectionInspectorProps = BlockInspectorProps &
  InspectorProps<"image">;

export function ImageSectionPreview(props: Readonly<ImageSectionProps>) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  const imageInspector = useContentfulInspectorMode({
    entryId: props.image?.sys?.id,
  });

  return (
    <ImageSection
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
        image: imageInspector({ fieldId: "image" }) ?? undefined,
      }}
    />
  );
}
